document.addEventListener('click', (e) => {
  const checkoutButton = e.target.closest('#checkout-button');
  if (!checkoutButton) return;
  e.preventDefault();

  const termsCheckbox = document.getElementById('terms-conditions-checkbox');
  const validationMessage = document.querySelector('.validation-message');

  if (!termsCheckbox || !termsCheckbox.checked) {
    if (termsCheckbox) {
      termsCheckbox.setAttribute('invalid', '');
      termsCheckbox.setAttribute('aria-invalid', 'true');
    }
    if (validationMessage) validationMessage.classList.remove('hidden');
    return;
  }

  window.location.href = '/checkout';
});

document.addEventListener('change', (e) => {
  if (e.target.id !== 'terms-conditions-checkbox') return;

  if (e.target.checked) {
    e.target.removeAttribute('invalid');
    e.target.removeAttribute('aria-invalid');
    const validationMessage = document.querySelector('.validation-message');
    if (validationMessage) validationMessage.classList.add('hidden');
  }
});
